import {
    GET_CONFIG_FORM30,    
    GET_DATOS_IMPLICADO_TERCERO,
    GET_COMBO_DOCUMENTOS,
    GET_URL_CARPETA,
    CLEAR_COMBO,
    GET_URL_CARPETA_ORIGEN
} from '../types';

export default function CarpetaDigitalReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM30:
            return { ...state, cfg_form30:action.payload }
        case GET_DATOS_IMPLICADO_TERCERO:
            return { ...state, datosImplicadoTercero:action.payload }
        case GET_COMBO_DOCUMENTOS:
            return { ...state, comboDocumentos:action.payload }
        case GET_URL_CARPETA:
            return { ...state, urlCarpeta:action.payload }
        case CLEAR_COMBO:
            return { ...state, limpiar:action.payload }
        case GET_URL_CARPETA_ORIGEN:
            return { ...state, respuestaUrl:action.payload }
        
       
       
       
        default:
            return state
    }
}